import {  Box } from "@mui/material";
import LoginForm from "components/loginForm";

const Login = () => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "Center",
                alignItems: "center",
            }}
        >
            <LoginForm />
        </Box>
    );
}

export default Login;